import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import MfaChallengeScreen from '../screens/MfaChallengeScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('mfa-otp-challenge')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MfaChallengeScreen />
    </StrictMode>,
  )
}

bootstrap()
